module.exports = __webpack_public_path__ + "6408ed245e0c272c6a456c193ebf16c3.svg";